<template>
    <v-container fluid>
        <v-layout justify-end v-if="unauthorized_requests.length && isParent">
            <v-flex xs12 md8>
                <v-list two-line style="border-radius: 20px;">
                    <v-subheader>requests</v-subheader>
                    <v-list-tile avatar v-for="request in unauthorized_requests"  :key="request.id">
                        <v-list-tile-action>
                            <v-btn icon @click="authorize(request.id, true)">
                                <v-icon >done</v-icon>
                            </v-btn>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ request.name}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ convertDate(request.date) }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-avatar>
                            <v-icon v-if="request.anonymous">account_circle</v-icon>
                            <img v-else :src="request.picture">
                        </v-list-tile-avatar>
                    </v-list-tile>
                </v-list>
            </v-flex>
        </v-layout>
        <v-layout justify-end v-if="isParent">
            <v-flex xs12 md8>
                <v-list two-line style="border-radius: 20px;">
                    <v-subheader>Participants</v-subheader>
                    <v-list-tile avatar v-for="request in requests" v-if="request.authorized" @click="true" :key="request.id">
                        <v-list-tile-action>
                            <v-btn icon @click.stop="deleteUser(request.id)">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ request.name}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ convertDate(request.date) }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-avatar>
                            <v-icon v-if="request.anonymous">account_circle</v-icon>
                            <img v-else :src="request.picture">
                        </v-list-tile-avatar>
                    </v-list-tile>
                </v-list>
            </v-flex>
        </v-layout>
        <v-dialog
            v-model="deleteDialog"
            max-width="290"
            >
            <v-card>
                <v-card-title class="headline">Do you really want to delete this participant ?</v-card-title>

                <v-card-text>
                    This action cannot be reverted.
                </v-card-text>

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="green darken-1"
                    flat="flat"
                    @click="deleteDialog = false"
                >
                    Disagree
                </v-btn>

                <v-btn
                    color="green darken-1"
                    flat="flat"
                    @click="deleteUserConfirmed"
                >
                    Agree
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { firestore, auth, storage, ui, uiConfig } from "@/firebase";
export default {
  props: {
    requests: Array,
    isParent: Boolean
  },
  data() {
    return {
      deleteDialog: false,
      userToDelete: null
    };
  },
  computed: {
    unauthorized_requests() {
      return this.requests.filter(request => !request.authorized);
    }
  },
  methods: {
    convertDate(date) {
      return new Date(date.seconds * 1000).toISOString().split("T")[0];
    },
    deleteUserConfirmed() {
      firestore
        .collection("babies")
        .doc(this.$route.params.id)
        .collection("requests")
        .doc(this.userToDelete)
        .delete();
      firestore
        .collection("babies")
        .doc(this.$route.params.id)
        .collection("pronos")
        .doc(this.userToDelete)
        .delete();
      this.deleteDialog = false;
    },
    deleteUser(id) {
      this.deleteDialog = true;
      this.userToDelete = id;
    },
    async authorize(id, authorized) {
      await firestore
        .collection("babies")
        .doc(this.$route.params.id)
        .collection("requests")
        .doc(id)
        .update({
          authorized
        });
    }
  }
};
</script>
